import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";

// InsertUpdate Table Data

export const WTPWaterQtyDataAPI = createAsyncThunk("WTPWaterQtyData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        WaterQtyM_IndicatorID,
        M_WTP_TimeID,
        ReadingDate,
        RawWater,
        SettledWater,
        FilteredWater,
        PureWater,
        LiterHours,
        PPM,
        KGHours,
        M_UserID,
        // Lit,
        token,
        setloading,
        handleIsPost,
        // handleOnCloseClick,
        handleFieldClear,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_FinancialYearID", M_FinancialYearID);
    formdata.append("M_MonthID", M_MonthID);
    formdata.append("WaterQtyM_IndicatorID", WaterQtyM_IndicatorID);
    formdata.append("M_WTP_TimeID", M_WTP_TimeID);
    formdata.append("ReadingDate", ReadingDate);
    formdata.append("RawWater", RawWater);
    formdata.append("SettledWater", SettledWater);
    formdata.append("FilteredWater", FilteredWater);
    formdata.append("PureWater", PureWater);
    formdata.append("LiterHours", LiterHours);
    formdata.append("PPM", PPM);
    formdata.append("KGHours", KGHours);
    // formdata.append("Lit", Lit);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setloading(true)
    fetch(`${BaseUrl}/Master/Post_WEB_WTP_T_WTP_WaterQuality_Insert`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            setloading(false)
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleOnCloseClick()
                handleFieldClear && handleFieldClear()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }

            return result
        })
})

const WTPWaterQtyDataSlice = createSlice({
    name: "WTPWaterQtyData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPWaterQtyDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPWaterQtyDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPWaterQtyDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPWaterQtyDataReducer = WTPWaterQtyDataSlice.reducer


// Get Table Data
export const WTPWaterQtyDataTableDataAPI = createAsyncThunk("WTPWaterQtyDataTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        WaterQtyM_IndicatorID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_WaterQuality_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&WaterQtyM_IndicatorID=${WaterQtyM_IndicatorID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                handleGetExport(result.data.table)
                return result.data.table
            } else {
                handleGetExport([])
                return result
            }
        })
})

const WTPWaterQtyDataTableDataSlice = createSlice({
    name: " WTPWaterQtyDataTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPWaterQtyDataTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPWaterQtyDataTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPWaterQtyDataTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPWaterQtyDataTableDataReducer = WTPWaterQtyDataTableDataSlice.reducer

// Delete API

export const WTPWaterQualityDeleteAPI = createAsyncThunk("WTPWaterQualityDelete", async ({ data }) => {

    const {
        T_WTP_WaterQualityID,
        M_UserID,
        handleIsPost,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_WTP_WaterQualityID", T_WTP_WaterQualityID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/WEB_WTP_T_WTP_WaterQuality_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
            } else {
                toastErrorr(result.message)
            }
            return result

        })
})

const WTPWaterQualityDeleteSlice = createSlice({
    name: "WTPWaterQualityDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPWaterQualityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPWaterQualityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            toastSuccesss(action.payload.message)
        });
        builder.addCase(WTPWaterQualityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPWaterQualityDeleteReducer = WTPWaterQualityDeleteSlice.reducer
